import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Dashboard from "../Component/Dashboard/dashboard";
import FrenchiseList from "../Component/Dashboard/FrenchiseList";
import Career from "../Component/Dashboard/Career/Getcareer";
import Appointment from "../Component/Dashboard/Bookappointent/Appointment";
import Forgetpassoword from "../pages/Forgetpassoword";

export default function AppRouter() {
  const routeData = [
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/forgot-password",
      element: <Forgetpassoword />,
    },
    {
      path: "/home",
      element: <Home />,
    },
    {
      path: "/admin",
      element: <Dashboard />,
      children: [
        {
          path: "franchise",
          element: <FrenchiseList />,
        },
        {
          path: "careers",
          element: <Career />
        },
        {
          path: "appointment",
          element: <Appointment/>
        }
      ],
    },
  ];

  return (
    <Routes>
      {routeData.map((item) => (
        <Route key={item.path} path={item.path} element={item.element}>
          {item.children?.map((child) => (
            <Route
              key={`${item.path}-${child.path}`}
              path={child.path}
              element={child.element}
            />
          ))}
        </Route>
      ))}
    </Routes>
  );
}
